import { replace } from 'lodash';
import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fCurrency(number) {
  return numeral(number).format(Number.isInteger(number) ? '$0,0' : '$0,0.00');
}

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return replace(numeral(number).format('0.00a'), '.00', '');
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}

export function fIndianAmount(value) {
  if (value === null || value === undefined || value === '') return value;
  const match = String(value)
    .replace(/,/g, '')
    .match(/^(-?)(\d*)(\.\d*)?$/);
  if (!match) return value;
  const [, sign, integerPart, decimalPart = ''] = match;
  const lastThree = integerPart.slice(-3);
  const leading = integerPart.slice(0, -3);
  const groupedInteger = leading
    ? `${leading.replace(/\B(?=(\d{2})+(?!\d))/g, ',')},${lastThree}`
    : lastThree;
  return `${sign}${groupedInteger}${decimalPart}`;
}

export function readIndianAmountInput(event) {
  const input = event.target;
  const rawValue = input.value.replace(/,/g, '');
  if (!/^-?\d*\.?\d*$/.test(rawValue)) return null;
  const caretFromEnd = input.value.length - (input.selectionStart ?? input.value.length);
  setTimeout(() => {
    const caret = Math.max(0, input.value.length - caretFromEnd);
    input.setSelectionRange(caret, caret);
  }, 0);
  return rawValue;
}

export function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}
